import alt from 'js/alt';
import { mapActions } from 'actions/MapActions';
import { criteriaActions } from 'actions/CriteriaActions';
import { loads } from 'js/config/config';

import _ from 'lodash';

import webMercatorUtils from 'esri/geometry/webMercatorUtils';

class CriteriaStore {
  constructor() {
    this.riskLevel = 'default';
    this.soilClass = 0;
    this.standardsVersion = '7-22';
    this.measurement = 'imperial';
    this.latitude = 'Latitude';
    this.longitude = 'Longitude';
    this.loads = loads;
    this.streetAddress = '';
    this.cityState = '';
    this.postal = '';
    this.search = {};
    this.selectionState = 'address';
    this.readyForReport = false;
    this.disableSoilClass = true;
    this.elevation = 0;
    this.elevationReferenceDatum = '';
    this.snapToAddress = false;
    this.activeLocationDiv = 'address';

    this.on('afterEach', () => {
      this.validateItemsForReport();
    });

    this.bindListeners({
      setCheckedLoads: criteriaActions.setCheckedLoads,
      setLatLon: criteriaActions.setLatLon,
      setRiskLevel: criteriaActions.riskLevelSelection,
      setStandardsVersion: criteriaActions.standardsVersionSelection,
      setMeasurement: criteriaActions.measurementsSelection,
      loadsClick: criteriaActions.loadsClick,
      toggleLocationDiv: criteriaActions.toggleLocationDiv,
      updateLocation: mapActions.searchSelectResult,
      setSoilClassSelection: criteriaActions.soilClassSelection,
      selectAllLoads: criteriaActions.selectAllLoads,
      setElevation: mapActions.setElevation,
      setElevationReferenceDatum: mapActions.setElevationReferenceDatum,
      updatedSnapToAddress: criteriaActions.updatedSnapToAddress,
    });
  }

  setCheckedLoads(selectedLoads) {
    selectedLoads.forEach((selectedLoad) => {
      const foundLoad = this.loads.find((load) => {
        return load.label === selectedLoad;
      });
      foundLoad.checked = 'checked';
    });
  }

  setLatLon(location) {
    this.latitude = location.latitude;
    this.longitude = location.longitude;
  }

  updatedSnapToAddress(value) {
    this.snapToAddress = value;
    this.emitChange();
  }

  selectAllLoads() {
    _.forEach(this.loads, (load) => {
      if (load.label === 'Tsunami') {
        if (this.standardsVersion === '7-10') {
          return;
        } else {
          load.checked = 'checked';
        }
      } else {
        load.checked = 'checked';
      }
    });
    this.disableSoilClass = false;
  }

  setElevation(elevation) {
    this.setState({ elevation: elevation });
  }

  setElevationReferenceDatum(datumCode) {
    let datum;
    switch (datumCode) {
      case '0':
        datum = 'Unknown';
        break;
      case '1':
        datum = 'Local Mean Sea Level';
        break;
      case '29':
        datum = 'National Geodetic Vertical Datum of 1929 (NGVD 29)';
        break;
      case '88':
        datum = 'North American Vertical Datum of 1988 (NAVD 88)';
        break;
      case '99':
        datum = 'Other';
        break;
      case '-1000000':
        datum = '';
        break;
      // case 'hawaii': datum = 'Mean High Water (MHW) datum';
      //   break;
    }
    this.setState({ elevationReferenceDatum: datum });
  }

  setRiskLevel(roman) {
    this.riskLevel = Number(roman);
  }

  setSoilClassSelection(level) {
    this.soilClass = level;
  }

  setStandardsVersion(version) {
    this.standardsVersion = version;
    this.setSoilClassSelection(-1);

    _.forEach(this.loads, (load) => {
      if (
        ((this.standardsVersion === '7-10' && load.label === 'Tsunami') ||
          (this.standardsVersion !== '7-22' && load.label === 'Tornado')) &&
        load.checked === 'checked'
      ) {
        load.checked = '';
      }
    });
  }

  setMeasurement(id) {
    this.measurement = id;
  }

  loadsClick(obj) {
    _.find(this.loads, { label: obj.id }).checked = obj.checked ? 'checked' : '';
    if (obj.id === 'Seismic') {
      this.disableSoilClass = !obj.checked;
    }
  }

  updateLocation(result) {
    this.setStreetAddress(result.address.Address);
    this.cityState = `${result.address.City}, ${result.address.Region}`;
    this.postal = result.address.Postal;
    this.setLocationValues(result.location);
    this.validateItemsForReport();
    this.emitChange();
  }

  toggleLocationDiv(selectionID) {
    this.activeLocationDiv = selectionID;
  }

  setLocationValues(feature) {
    let lnglat = webMercatorUtils.xyToLngLat(feature.x, feature.y);
    this.longitude = parseFloat(lnglat[0].toFixed(6));
    this.latitude = parseFloat(lnglat[1].toFixed(6));
  }

  clearLocationValues() {
    this.streetAddress = '';
    this.cityStatePostal = '';
  }

  setStreetAddress(name) {
    this.streetAddress = name;
  }

  validateItemsForReport() {
    // To be ready: must have risk category, latitude & longitude, at least 1 load checked, and if seismic, must have valid soil class
    const ignoreRiskCategorySelection = this.standardsVersion === '41-17' || this.standardsVersion === '41-23';
    let validRiskLevel = this.riskLevel > 0 || ignoreRiskCategorySelection;
    let validLocation = this.latitude !== 0 && this.longitude !== 0;
    let loadChecked = !_.every(this.loads, { checked: '' });
    let validSoilClass = false;

    let seismicCheck = _.find(this.loads, { label: 'Seismic', checked: 'checked' });
    if (seismicCheck) {
      if ((this.standardsVersion === '7-10' && this.soilClass > 5) || this.soilClass === -1) {
        validSoilClass = false;
      } else {
        validSoilClass = true;
      }
    } else {
      validSoilClass = true;
    }

    if (validRiskLevel && validLocation && loadChecked && validSoilClass) {
      this.readyForReport = true;
    } else {
      this.readyForReport = false;
    }
  }
}

export const criteriaStore = alt.createStore(CriteriaStore, 'CriteriaStore');
